import { ICreateManutencaoEquipObraUseCase } from "../../../presentation/useCases/create/create_manutencao_equip_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

export class CreateManutencaoEquipObraUseCase implements ICreateManutencaoEquipObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(
    idObra?: number,
    status?: boolean,
    descricao?: string,
    dataManutencao?: Date,
    dataProxManutencao?: Date,
    dataPrevDevolucao?: Date,
    dataDevolucao?: Date,
    parteEletrica?: string,
    parteMecanica?: string,
    lubrificacao?: string,
    limpeza?: string,
    observacao?: string,
    outros1?: string,
    outros2?: string,
    descEquipamento?: string,
    idFornecedor?: number,
    descLocatario?: string,
    statusDevolucao?: boolean,
  ): Promise<number> {
    return await this.repository.createManutencaoEquipObra({
      idManutencaoEquipObra: 0,
      idObra,
      status,
      descricao,
      dataManutencao,
      dataProxManutencao,
      dataPrevDevolucao,
      dataDevolucao,
      parteEletrica,
      parteMecanica,
      lubrificacao,
      limpeza,
      observacao,
      outros1,
      outros2,
      descEquipamento,
      idFornecedor,
      descLocatario,
      statusDevolucao
    });

  }
}
